// ユーザー関連ページのスクリプト

// ユーザー作成・編集でオーナー権限を選択時、胴元を変更可能にする
$(document).on('change', '#auth-type-selector', () => {
  auth_type = $('#auth-type-selector').find('option:selected').val()

  if (auth_type == 'owner') {
    $('#owners-boss-selector').prop('disabled', false)
    $('#owner-code-field').prop('disabled', false)
    $('#owner-company-field').prop('disabled', false)
    displayPublicInfoForm()
  } else {
    $('#owners-boss-selector').prop('disabled', true)
    $('#owner-code-field').prop('disabled', true)
    $('#owner-company-field').prop('disabled', true)
    hidePublicInfoForm()
  }

  if (auth_type == 'employee') {
    $('#employer-selector').prop('disabled', false)
  } else {
    $('#employer-selector').prop('disabled', true)
  }

  if (auth_type == 'call_center' || auth_type == 'supervisor') {
    $('#assign-hotel-selector').prop('disabled', false)
    $('.ms-elem-selectable').removeClass('disabled')
    $('.ms-elem-selection').removeClass('disabled')
  } else {
    $('#assign-hotel-selector').prop('disabled', true)
    $('.ms-elem-selectable').addClass('disabled')
    $('.ms-elem-selection').addClass('disabled')
  }
});

function displayPublicInfoForm () {
  $('.public-info-form').prop('disabled', false)
  $('.public-info-form-area').css('display', 'block')
}

function hidePublicInfoForm () {
  $('.public-info-form').val('')
  $('.public-info-form').prop('disabled', true)
  $('.public-info-form-area').hide()
}
